import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./PdfListModal.scss";
import pdfIcon from "../../../../../img/pdf.png";
import { logAction } from "../../../../../core/services/logs";

const PdfListModal = ({ handleClose, reports }) => {
  const [searchTerm, setSearchTerm] = useState();

  function downloadMe(e) {
    e.preventDefault();
    logAction("DownloadPDF", null);
    if (e.target.tagName === "IMG") {
      window.open(e.target.parentNode.href, "_blank");
    } else if (e.target.tagName === "A") {
      window.open(e.target.href, "_blank");
    }
  }

  const reportsList = reports
    .filter((item) => {
      return !searchTerm
        ? true
        : new RegExp(searchTerm, "i").test(item.description);
    })
    .map((report) => {
      return (
        <li key={report.namePath} className="repport">
          <span className="repport__date">{report.dateCreatePdf}</span>
          <a
            className="repport__title"
            href={`https://www.energymarketprice.com/Flink/server/Energy/ReadPDF/${report.namePath}`}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => downloadMe(e)}
          >
            {report.description}
            <img
              className="repport__download"
              src={pdfIcon}
              alt="download pdf"
              title="download pdf"
            />
          </a>
        </li>
      );
    });

  return ReactDOM.createPortal(
    <div className="reports-modal">
      <section className="modal-main">
        <div className="modal-header">
          <button type="button" className="close-modal" onClick={handleClose}>
            &times;
          </button>
          <h2>All reports</h2>
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="modal-body">
          <ul className="pdf-reports">{reportsList}</ul>
        </div>
      </section>
    </div>,
    document.getElementById("emp-modal")
  );
};

export default PdfListModal;
